var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3C3.89543 3 3 3.89543 3 5V9.12868C2.38315 9.40334 1.99625 10.0804 2.13901 10.7942L3.85862 19.3922C4.04559 20.3271 4.86643 21 5.81979 21H18.1802C19.1335 21 19.9544 20.3271 20.1413 19.3922L21.861 10.7942C22.0037 10.0804 21.6168 9.40337 21 9.1287V7.5C21 6.39543 20.1046 5.5 19 5.5H12.4806L11.0811 3.75061C10.7016 3.27618 10.1269 3 9.51938 3H5ZM19 9V7.5H12.4806C11.8731 7.5 11.2984 7.22382 10.9189 6.74939L9.51938 5H5V9H19Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.045c94f9f8f01dd4cf6871b8d5735de0.svg";
export { ForwardRef as ReactComponent };